import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import {
  ListGroupItem,
  ListGroupItemHeading,
  Row,
  Col,
  Collapse,
} from 'reactstrap';
import { format } from 'date-fns';

const SubmissionSummary = ({ submission }) => {
  const [isCollapseOpen, setIsCollapseOpen] = useState(false);

  return (
    <ListGroupItem
      action
      onClick={() => setIsCollapseOpen(wasOpen => !wasOpen)}
    >
      <ListGroupItemHeading>
        <Row>
          <Col md={10}>
            <p>{submission.crisis} crisis on {format(submission.dateTime, 'MM/DD/YYYY')}</p>
          </Col>

          <Col md={2}>
            <FontAwesomeIcon
              icon={isCollapseOpen ? 'chevron-up' : 'chevron-down'}
              className="float-right text-muted"
              fixedWidth
            />
          </Col>
        </Row>
      </ListGroupItemHeading>

      <Collapse isOpen={isCollapseOpen}>
        <Row>
          <Col>
            <h6 className="font-weight-bold">Reporting Officer</h6>
            <p>{submission.officerName}</p>
          </Col>

          <Col>
            <h6 className="font-weight-bold">CIT Trained</h6>
            <p>{submission.officerCit ? 'Yes' : 'No'}</p>
          </Col>
        </Row>

        <Row>
          <Col sm={6}>
            <h6 className="font-weight-bold">Incident Location</h6>
            <p>
              {submission.locationAddr1} {submission.locationAddr2} {submission.locationCity},{' '}
              {submission.locationStateLabel} {submission.locationPostCode}
            </p>
          </Col>

          <Col sm={3}>
            <h6 className="font-weight-bold">Incident County</h6>
            <p> {submission.locationCounty} </p>
          </Col>

          <Col sm={3}>
            <h6 className="font-weight-bold">Location Type</h6>
            <p>{submission.type}</p>
          </Col>
        </Row>

        <Row>
          <Col>
            <h6 className="font-weight-bold">Person/Agency Reporting</h6>
            <p>
              {submission.referralSourceLabel}
            </p>
          </Col>

          <Col>
            <h6 className="font-weight-bold">Juvenile</h6>
            <p>{submission.juvenile ? 'Yes' : 'No'}</p>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col sm={3}>
            <h6 className="font-weight-bold">Response</h6>
            <p>{submission.response}</p>
          </Col>

          <Col sm={3}>
            <h6 className="font-weight-bold">Weapons Involved</h6>
            <p>{submission.weaponInvolved?.join(', ')}</p>
          </Col>

          <Col sm={3}>
            <h6 className="font-weight-bold">Injury Resulted From Force?</h6>
            <p>{submission.injuryResultedFromForce}</p>
          </Col>

          <Col sm={3}>
            <h6 className="font-weight-bold">Injured Parites</h6>
            <p>{submission.forceUsedIncidentResultedInInjury?.join(', ')}</p>
          </Col>
        </Row>

        <Row>
          <Col sm={4}>
            <h6 className="font-weight-bold">Disposition</h6>
            <p>{submission.dispositionLabel}</p>
          </Col>
          <Col sm={4}>
            <h6 className="font-weight-bold">Referral to a Mental Health Facility</h6>
            <p>{submission.mHFollowUpRequested ? 'Yes' : 'No'}</p>
          </Col>

          {submission.mHFollowUpRequested &&
            <Col sm={4}>
              <h6 className="font-weight-bold">Facility</h6>
              <p>{submission.facilityName}</p>
            </Col>
          }
        </Row>
        <Row>
          {submission.transportBy &&
          <Col sm={4}>
            <h6 className="font-weight-bold">Transported By</h6>
            <p>{submission.transportBy}</p>
          </Col>
          }
          {submission.destination &&
          <Col sm={4}>
            <h6 className="font-weight-bold">Destination</h6>
            <p>{submission.destination}</p>
          </Col>
          }
        </Row>
        <Row>
          <Col sm={4}>
            <h6 className="font-weight-bold">Taken in for Emergency Custody</h6>
            <p>{submission.subjectTakenIntoCustodyForEvaluation ? 'Yes' : 'No'}</p>
          </Col>

          <Col sm={4}>
            <h6 className="font-weight-bold">Evaluation Initiated By</h6>
            <p>{submission.processInitiatedBy}</p>
          </Col>
        </Row>
        <Row>
          <Col sm={4}>
            <h6 className="font-weight-bold">Incident Has Related Crime?</h6>
            <p>{submission.incidentHasRelatedCrime ? 'Yes' : 'No'}</p>
          </Col>

          <Col sm={4}>
            <h6 className="font-weight-bold">Charges To Be Filed?</h6>
            <p>{submission.criminalChargesToBeFiled}</p>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col>
            <h6 className="font-weight-bold">Notes</h6>
            <p>{submission.incidentNote}</p>
          </Col>
        </Row>
      </Collapse>
    </ListGroupItem>
  );
};

SubmissionSummary.propTypes = {
  submission: PropTypes.shape({}).isRequired,
};

export default SubmissionSummary;
